/**
 * This function retrieves the ticker symbol from the current URL's path.
 *
 * @function getTicker
 * @returns {string} The ticker symbol derived from the last segment of the URL path, converted to uppercase.
 */
export const getTicker = (): string => {
  const currentPath = window.location.href;
  const symbol = currentPath.substring(currentPath.lastIndexOf("/") + 1).toUpperCase();
  return symbol;
};
